import { defineAsyncComponent } from 'vue'
export default {
  cabinet: defineAsyncComponent(() => import("/var/www/2025-07-16_14_46/layouts/cabinet.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/var/www/2025-07-16_14_46/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/var/www/2025-07-16_14_46/layouts/empty.vue").then(m => m.default || m))
}